import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { DesktopSidebar } from './DesktopSidebar';
import { DesktopHeader } from './DesktopHeader';
import { MobileHeader } from './MobileHeader';
import { MobileBottomNav } from './MobileBottomNav';
import { RecordActivityModal } from './RecordActivityModal';
import { MoreMenuDrawer } from './MoreMenuDrawer';
import { BugReportModal } from '@/components/bugs/BugReportModal';
import { useBugReport } from '@/context/BugReportContext';
import { PwaInstallBanner } from '@/components/common/PwaInstallBanner';
import { TooltipProvider } from '@/components/ui/tooltip';

export const AppLayout: React.FC = () => {
  const [selectedFarmId, setSelectedFarmId] = useState<string | null>(null);
  const [isRecordActivityOpen, setIsRecordActivityOpen] = useState<boolean>(false);
  const [isMoreDrawerOpen, setIsMoreDrawerOpen] = useState<boolean>(false);
  const { isOpen: isBugReportOpen, closeBugReport, contextHint } = useBugReport();

  return (
    <TooltipProvider delayDuration={250} skipDelayDuration={150}>
      <div className="min-h-screen bg-slate-50 flex flex-col antialiased selection:bg-emerald-100 selection:text-emerald-900">
      {/* PWA Install Banner */}
      <PwaInstallBanner />

      <div className="flex-1 flex flex-row">
        {/* Desktop Sidebar (Left 240px navy) */}
        <DesktopSidebar />

        {/* Main Content Workspace */}
        <div className="flex-1 flex flex-col min-w-0">
          {/* Desktop Top Header */}
          <DesktopHeader
            onOpenRecordActivity={() => setIsRecordActivityOpen(true)}
            selectedFarmId={selectedFarmId}
            onSelectFarm={setSelectedFarmId}
          />

          {/* Mobile Top Header */}
          <MobileHeader
            onOpenDrawer={() => setIsMoreDrawerOpen(true)}
            selectedFarmId={selectedFarmId}
            onSelectFarm={setSelectedFarmId}
          />

          {/* Dynamic Page Outlet */}
          <main className="flex-1 p-4 sm:p-6 lg:p-8 pb-24 lg:pb-8 max-w-7xl w-full mx-auto">
            <Outlet context={{ selectedFarmId }} />
          </main>
        </div>
      </div>

      {/* Mobile Bottom Navigation Bar (4 tabs + floating + button) */}
      <MobileBottomNav
        onOpenRecordActivity={() => setIsRecordActivityOpen(true)}
        onOpenMoreDrawer={() => setIsMoreDrawerOpen(true)}
      />

      {/* Record Activity Launcher Modal (9 tiles) */}
      <RecordActivityModal
        isOpen={isRecordActivityOpen}
        onClose={() => setIsRecordActivityOpen(false)}
      />

      {/* Mobile More Menu Drawer */}
      <MoreMenuDrawer
        isOpen={isMoreDrawerOpen}
        onClose={() => setIsMoreDrawerOpen(false)}
      />

      {/* Global In-App Bug Report Modal */}
      <BugReportModal
        isOpen={isBugReportOpen}
        onClose={closeBugReport}
        selectedFarmId={selectedFarmId}
        contextHint={contextHint}
      />
    </div>
    </TooltipProvider>
  );
};

